<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {exitLogin} from '@/api/user/login'
import { APP_PATH} from '@/utils/url'
import { addView } from "@/api/basics/banner";

export default {
  data(){
    return{
        isLoading: false,
        isWeChatBrowser: null,
        isMobileBrowser: null,
        localIsLoading: true,
      }
    },
  created(){
    let user = this.$storage.getStorage('userInfo')
    if(!user){
      exitLogin().then(res=>{
        console.log('resresresresres',res);
        this.$cookie.removeCookie('userInfo')
        this.$storage.removeStorage('userInfo')
        localStorage.clear()
      })
    }
  },
  mounted(){
    this.addViews()
    this.$cookie.setCookie('orgId','')
    // window.addEventListener('resize', this.handleResize);
    this.checkBrowser()
    // this.handleResize()
  },
  methods:{
    // 增加页面浏览量
    addViews() {
      const params = {
        type: 0,
        module: 222,
      };
      addView(params).then((res) => {
        // console.log("zhengti", res);
      });
    },
    handleResize(){
      const width = window.innerWidth;

      if (width <= 900 || this.isMobileBrowser) {
        let baseurl = ''
        if (this.$route.path == '/') {
          baseurl = APP_PATH + '/Cloud-App' + '#/'
        }else if(this.$route.path =='/Train/List'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_train/pages/list?navigate=培训报名'
        }else if(this.$route.path =='/Train/Detail'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_train/pages/detail?id='+this.$route.query.trainId
        }else if(this.$route.path =='/Activity/List'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_activity/pages/list?navigate=活动预约'
        }else if(this.$route.path =='/Activity/Detail'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_activity/pages/detail?id='+this.$route.query.id
        }else if(this.$route.path =='/Venue/List'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_organization/pages/list?navigate=场馆预订'
        }else if(this.$route.path =='/Venue/Detail'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_organization/pages/detail?id='+this.$route.query.id
        }else if(this.$route.path =='/Field/Room'){
          baseurl = APP_PATH + '/Cloud-App' + '#/pages_field/pages/detail?id='+this.$route.query.fieldId
        }
        window.location.replace(baseurl);
      }
    },
    checkBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('micromessenger') !== -1) {
        this.isWeChatBrowser = true
        this.isLoading = true
      } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('android') !== -1) {
        this.isMobileBrowser = true
        this.isLoading = true
      } else {
        console.log('11111未知')
        this.isLoading = false
      }
    },
  }
}
</script>
<style lang="less">
#app {
  color: #333;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #333;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
/* 让 Message 回到 16 px 世界，不影响页面其他 rem */
.el-message {
  font-size: 16px !important;   /* 关键：弹窗自己的根字号 */
  padding: 12px 16px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
.el-message__icon {
  font-size: 14px !important;
  margin-right: 8px !important;
}
.el-message__content {
  font-size: 14px !important;
}
.el-message__closeBtn {
  font-size: 14px !important;
}

@font-face {
font-family: "myFont";
src: url("~@/assets/BaoTu.ttf");
}
</style>
